const locale = {
  placeholder: 'انتخاب زمان',
};

export default locale;
